import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "onChange", "name", "defaultValue", "value", "disabled", "children"];
import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useControlled } from '../utils';
import { CheckboxContext } from './context';
var CheckboxGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    onChange = props.onChange,
    name = props.name,
    defaultValue = props.defaultValue,
    valueProp = props.value,
    disabled = props.disabled,
    children = props.children,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useControlled = useControlled(valueProp, defaultValue),
    value = _useControlled[0],
    setValue = _useControlled[1],
    isControlled = _useControlled[2];
  var handleChange = useCallback(function (nextValue, checked, event) {
    var newValues;
    if (checked) {
      newValues = [].concat(value || [], [nextValue]);
    } else {
      newValues = (value || []).filter(function (val) {
        return val !== nextValue;
      });
    }
    setValue(newValues);
    onChange === null || onChange === void 0 ? void 0 : onChange(newValues, event);
  }, [onChange, setValue, value]);
  var contextValue = useMemo(function () {
    return {
      name: name,
      value: value,
      disabled: disabled,
      controlled: isControlled,
      onChange: handleChange
    };
  }, [disabled, handleChange, name, value, isControlled]);
  var prefixCls = customizePrefixCls ? customizePrefixCls + "-checkbox" : 'ap-checkbox';
  return /*#__PURE__*/React.createElement(CheckboxContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", _extends({
    role: "group",
    className: classNames(prefixCls + "-group", className)
  }, restProps), children));
});
CheckboxGroup.displayName = 'CheckboxGroup';
export default CheckboxGroup;